import { useCallback } from 'react';

import { ScopeModel } from '../../../../../modules/Apps';
import { useScopesTableContext } from '../../ScopesTableContext';

export const useScopesTableActions = () => {
  const { editScopeDrawerState, viewScopeDrawerState, setEditingScope } = useScopesTableContext();

  const openEditScopeDrawer = useCallback(
    (scope: ScopeModel) => () => {
      setEditingScope(scope);
      editScopeDrawerState.show();
    },
    [editScopeDrawerState, setEditingScope],
  );

  const openViewScopeDrawer = useCallback(
    (scope: ScopeModel) => () => {
      setEditingScope(scope);
      viewScopeDrawerState.show();
    },
    [viewScopeDrawerState, setEditingScope],
  );

  return {
    openEditScopeDrawer,
    openViewScopeDrawer,
  };
};
